import {
  DiscussionTargetType,
  TargetCandidate,
} from '../../../../../domain/entity/DiscussionEntity'

export type FilterOption = {
  value: string
  label: string
}

export type FilterTypeKey = 'target'

export type FilterTypeConfig = {
  key: FilterTypeKey
  getLabelId: (candidates: TargetCandidate[]) => string
  getPlaceholderId: (candidates: TargetCandidate[]) => string
  getOptions: (candidates: TargetCandidate[]) => FilterOption[]
  isAvailable: (candidates: TargetCandidate[]) => boolean
}

const inferTargetType = (
  candidates: TargetCandidate[]
): DiscussionTargetType | null => {
  if (candidates.length === 0) return null
  return candidates[0].type
}

// 対象の種類ごとの文言。種類が増えたときに書き漏れを型で検出できるよう、表で持つ
const LABEL_IDS: Record<DiscussionTargetType, string> = {
  PROCESS: 'discussion.filter.type.process',
  TEAM: 'discussion.filter.type.team',
  TICKET_LIST: 'discussion.filter.ticketList',
}
const PLACEHOLDER_IDS: Record<DiscussionTargetType, string> = {
  PROCESS: 'discussion.filter.search.process',
  TEAM: 'discussion.filter.search.team',
  TICKET_LIST: 'discussion.filter.ticketListSearch',
}

// 候補が無いときは工程として扱う（変更前と同じ）
const targetTypeOf = (candidates: TargetCandidate[]): DiscussionTargetType =>
  inferTargetType(candidates) ?? 'PROCESS'

export const FILTER_TYPES: FilterTypeConfig[] = [
  {
    key: 'target',
    getLabelId: candidates => LABEL_IDS[targetTypeOf(candidates)],
    getPlaceholderId: candidates => PLACEHOLDER_IDS[targetTypeOf(candidates)],
    getOptions: candidates =>
      candidates.map(c => ({ value: c.uuid, label: c.name })),
    isAvailable: candidates => candidates.length > 0,
  },
]
